var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-module", class: _vm.modifierClasses },
    [
      _vm.isPillAvailable
        ? _c(
            "div",
            {
              staticClass: "text-module__pill-container",
              class: _vm.pillModifierClasses,
            },
            [
              _c(
                "rb-pill",
                { attrs: { size: "small", color: _vm.pillColorClass } },
                [_vm._v("\n      " + _vm._s(_vm.pill) + "\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isImageAvailable
        ? _c(
            "div",
            {
              staticClass:
                "text-module__container text-module__image-container",
            },
            [_vm._t("image")],
            2
          )
        : _vm.isImageBlockAvailable
        ? _vm._t("image_block")
        : _vm._e(),
      _vm._v(" "),
      _vm.isCountdownAvailable
        ? _c(
            "div",
            {
              staticClass:
                "text-module__container text-module__countdown-container",
            },
            [
              _c(
                "rb-countdown",
                _vm._b({}, "rb-countdown", _vm.countdownProps, false)
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCopyBlockAvailable || _vm.isCopyAvailable || _vm.isMessageAvailable
        ? _c(
            "div",
            {
              staticClass:
                "text-module__container text-module__title-and-excerpt-container",
            },
            [
              _vm.isMessageAvailable
                ? _c(
                    "p",
                    {
                      staticClass: "text-module__message",
                      class: _vm.textModuleMessageColor,
                    },
                    [_vm._t("message")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isTitleAvailable
                ? _c(
                    _vm.headingTag,
                    { tag: "component", staticClass: "text-module__title" },
                    [_vm._t("title")],
                    2
                  )
                : _vm.isTitleBlockAvailable
                ? _c(
                    "div",
                    { staticClass: "text-module__title" },
                    [_vm._t("title_block")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isExcerptAvailable
                ? _c(
                    "p",
                    { staticClass: "text-module__excerpt" },
                    [_vm._t("excerpt")],
                    2
                  )
                : _vm.isExcerptBlockAvailable
                ? _c(
                    "div",
                    { staticClass: "text-module__excerpt" },
                    [_vm._t("excerpt_block")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isSubtitleAvailable
                ? _c(
                    "p",
                    { staticClass: "text-module__subtitle" },
                    [_vm._t("subtitle")],
                    2
                  )
                : _vm.isSubtitleBlockAvailable
                ? _c(
                    "div",
                    { staticClass: "text-module__subtitle" },
                    [_vm._t("subtitle_block")],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSearchAvailable
        ? _c("rb-get-support-search-bar", { attrs: { theme: _vm.theme } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isCtaContainerAvailable
        ? _c(
            "div",
            {
              staticClass: "text-module__container text-module__cta-container",
            },
            [
              _vm.isCtaAvailable
                ? [
                    _vm.isCta1Available ? _vm._t("cta_1") : _vm._e(),
                    _vm._v(" "),
                    _vm.isCta2Available ? _vm._t("cta_2") : _vm._e(),
                  ]
                : _vm.isCtaBlockAvailable
                ? [_vm._t("cta_block")]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }